function cov_1dl7jkuj0t() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/CheckEmailForm.tsx";
  var hash = "01276487c3b531c8eb7cea034443c4d0c3f6196b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/CheckEmailForm.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 57
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "1": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 26,
          column: 89
        }
      },
      "2": {
        start: {
          line: 27,
          column: 27
        },
        end: {
          line: 29,
          column: 41
        }
      },
      "3": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 81,
          column: 4
        }
      },
      "4": {
        start: {
          line: 49,
          column: 30
        },
        end: {
          line: 49,
          column: 57
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 57
          },
          end: {
            line: 19,
            column: 58
          }
        },
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 82,
            column: 1
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 49,
            column: 23
          },
          end: {
            line: 49,
            column: 24
          }
        },
        loc: {
          start: {
            line: 49,
            column: 30
          },
          end: {
            line: 49,
            column: 57
          }
        },
        line: 49
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 21
          },
          end: {
            line: 26,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 44
          },
          end: {
            line: 26,
            column: 67
          }
        }, {
          start: {
            line: 26,
            column: 70
          },
          end: {
            line: 26,
            column: 89
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 29,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 47
          }
        }, {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 29,
            column: 41
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 7
          },
          end: {
            line: 79,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 68,
            column: 11
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 78,
            column: 10
          }
        }],
        line: 42
      },
      "3": {
        loc: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 53,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 44,
            column: 31
          }
        }, {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 52,
            column: 14
          }
        }],
        line: 44
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "01276487c3b531c8eb7cea034443c4d0c3f6196b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1dl7jkuj0t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1dl7jkuj0t();
import React from 'react';
import { Box, Button, Link, Text } from '@opendoor/bricks-next';
import { t } from "../../i18n/translationHelper.mjs";
cov_1dl7jkuj0t().s[0]++;
var CheckEmailForm = function CheckEmailForm(_ref) {
  var hasGeneratedPassword = _ref.hasGeneratedPassword,
    email = _ref.email,
    analyticsName = _ref.analyticsName,
    onResetValidEmail = _ref.onResetValidEmail,
    requestResetPassword = _ref.requestResetPassword;
  cov_1dl7jkuj0t().f[0]++;
  var headerText = (cov_1dl7jkuj0t().s[1]++, hasGeneratedPassword ? (cov_1dl7jkuj0t().b[0][0]++, t('setUpAccountHeader')) : (cov_1dl7jkuj0t().b[0][1]++, t('checkYourEmail'))),
    emailInstructionText = (cov_1dl7jkuj0t().s[2]++, hasGeneratedPassword ? (cov_1dl7jkuj0t().b[1][0]++, t('setUpAccountDescription', {
      email: email
    })) : (cov_1dl7jkuj0t().b[1][1]++, t('resetPasswordSent', {
      email: email
    })));
  cov_1dl7jkuj0t().s[3]++;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "$20x"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "$10x"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    typography: "$headerMedium"
  }, headerText), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    typography: "$bodySmall"
  }, emailInstructionText)), hasGeneratedPassword ? (cov_1dl7jkuj0t().b[2][0]++, /*#__PURE__*/React.createElement(React.Fragment, null, (cov_1dl7jkuj0t().b[3][0]++, requestResetPassword) && (cov_1dl7jkuj0t().b[3][1]++, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "small",
    label: t('resendEmail'),
    onPress: function onPress(_) {
      cov_1dl7jkuj0t().f[1]++;
      cov_1dl7jkuj0t().s[4]++;
      return requestResetPassword(email);
    },
    analyticsName: "".concat(analyticsName, "-resend-reset-password-email"),
    "aria-label": t('resendEmail')
  })), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    typography: "$bodyMedium"
  }, t('resetPasswordSentWithoutSignInAgain', {
    email: email
  }), ' ', /*#__PURE__*/React.createElement(Link, {
    variant: "primary",
    href: "/login",
    size: "medium",
    onPress: onResetValidEmail,
    analyticsName: "".concat(analyticsName, "-sign-in-after-reset-password"),
    "aria-label": t('signIn'),
    "data-testid": "sign-in-after-reset-password"
  }, t('signInAgain'))))) : (cov_1dl7jkuj0t().b[2][1]++, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "small",
    label: t('signIn'),
    onPress: onResetValidEmail,
    analyticsName: "".concat(analyticsName, "-sign-in-after-reset-password"),
    "aria-label": t('signIn'),
    "data-testid": "sign-in-after-reset-password"
  })));
};
export default CheckEmailForm;
//# sourceMappingURL=CheckEmailForm.mjs.map